import React, { Component } from "react";
import { BarChart, ResponsiveContainer, Bar, XAxis, Tooltip } from "recharts";
import { Panel } from "common";
import { NoData } from "./NoData";
import { connect } from "react-redux";

class InstagramReach extends Component {
  render() {
    let data = [];
    if (
      this.props.instagramReachCurrentMonthSelection &&
      this.props.instagramReachTwoMonthsAgo &&
      this.props.instagramReachThreeMonthsAgo
    ) {
      data = [
        this.props.instagramReachThreeMonthsAgo,
        this.props.instagramReachTwoMonthsAgo,
        this.props.instagramReachCurrentMonthSelection,
      ];
    }
    const isLoading =
      this.props.instagramCurrentMonthLoadState === true &&
      this.props.instagramTwoMonthsAgoLoadState === true &&
      this.props.instagramThreeMonthsAgoLoadState === true;
    return this.props.instagramReachCurrentMonthSelection === null &&
      this.props.instagramReachTwoMonthsAgo === null &&
      this.props.instagramReachThreeMonthsAgo === null ? (
      <NoData title={"No Reach Data Available"} />
    ) : (
      <Panel
        containerClass="col-md-6 p-3 float-left"
        isLoading={isLoading}
        errors={this.props.errors}
        padding={2}
      >
        <Panel.Subtitle
          text={"Page Reach 3 Months"}
          bubbleValues={["Organic", "Paid"]}
        />
        <Panel.Body
          render={() => {
            return (
              <ResponsiveContainer width="100%" height={230}>
                <BarChart
                  width={600}
                  height={300}
                  data={data}
                  margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
                >
                  <XAxis dataKey="name" />
                  <Tooltip
                    formatter={(value) =>
                      new Intl.NumberFormat("en").format(value)
                    }
                  />
                  <Bar dataKey="Reach" fill="rgb(97, 155, 249)" />
                </BarChart>
              </ResponsiveContainer>
            );
          }}
        />
      </Panel>
    );
  }
}
const mapStateToProps = (state) => ({
  instagramReachCurrentMonthSelection:
    state.social.instagramReachCurrentMonthSelection,
  instagramReachTwoMonthsAgo: state.social.instagramReachTwoMonthsAgo,
  instagramReachThreeMonthsAgo: state.social.instagramReachThreeMonthsAgo,
  instagramCurrentMonthLoadState: state.social.instagramCurrentMonthLoadState,
  instagramTwoMonthsAgoLoadState: state.social.instagramTwoMonthsAgoLoadState,
  instagramThreeMonthsAgoLoadState:
    state.social.instagramThreeMonthsAgoLoadState,
});

const connected = connect(mapStateToProps, {})(InstagramReach);

export { connected as InstagramReach };
